import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import type { Role } from '@bcc/shared';

export function RequireAuth({
  children,
  roles,
}: {
  children: React.ReactElement;
  roles?: Role[];
}) {
  const { session, loading, profile } = useAuth();
  const location = useLocation();
  const redirectTo = `${location.pathname}${location.search}`;

  if (loading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center text-sm text-slate-400">
        Loading...
      </div>
    );
  }
  if (!session) {
    return <Navigate to="/login" replace state={{ redirect: redirectTo }} />;
  }
  if (!profile) {
    return <Navigate to="/login" replace state={{ redirect: redirectTo }} />;
  }
  if (roles && roles.length > 0 && !roles.includes(profile.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
